import React from "react";
import ResearchArticle from "../components/portfolio/ResearchArticle";
import AddToBagDemo from "../components/AddToBagDemo";
import { relatedArticles } from "../data/articles";

// The one playable page in the portfolio. It runs on the same article shell as
// the case studies — the same masthead, the same reading column, the same
// closing offer — so a demo does not read like a page from another site. Only
// the demo inside it keeps its own look and behaviour.
//
// No chapters, so the shell renders no contents rail: with one section there is
// nothing to navigate between.

const REPO = {
  title: "Source code",
  description:
    "The full implementation of the “Add to Bag” animation, built with Rive, Framer Motion, and React.",
  label: "View on GitHub",
  href: "https://github.com/orabadanux/motion-addToBag",
  external: true,
};

function AddToBagAnim() {
  return (
    <ResearchArticle
      eyebrow="Motion demo"
      title="Add to bag animation demo"
      lead="A microinteraction built with Rive, Framer Motion, and React to simulate a product card flying into a shopping bag."
      deck={REPO}
      related={relatedArticles("/add-to-bag-demo")}
    >
      <div className="flex justify-center">
        <AddToBagDemo />
      </div>
    </ResearchArticle>
  );
}

export default AddToBagAnim;
